// @ts-nocheck
'use client';

import './styles/default.scss';
import { useEffect, useRef, useState } from 'react';
import { defaultLoadMetadata, onError } from './video.utils';
import type { VideoPlayerProps } from './video.types';
import videojs from 'video.js';
import 'video.js/dist/video-js.css';
// eslint-disable-next-line nextjs-boundaries/no-server-import-in-client
import { Spinner } from '../spinner';

export const VideoPlayer = ({
    options,
    onReady,
    onLoadMetadata,
    onVideoCanPlay,
    videoId,
    shouldShowSpinner = true,
    suppressNativePoster = false
}: VideoPlayerProps) => {
    const handleLoadMetadata = onLoadMetadata || defaultLoadMetadata;

    const videoRef = useRef(null);
    const playerRef = useRef(null);
    const fallbackTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
    const [isVideoReady, setIsVideoReady] = useState(!shouldShowSpinner);

    useEffect(() => {
        const videoElement = document.createElement('video-js');
        videoElement.classList.add('vjs-big-play-centered');

        // @ts-expect-error — video.js typing mismatch
        const player = (playerRef.current = videojs(videoElement, options, () => {
            onReady?.(player, videoId);

            onError(player, setIsVideoReady);
            handleLoadMetadata?.(player);

            player.on('loadedmetadata', () => {
                const videoWidth = player.videoWidth();
                const videoHeight = player.videoHeight();
                if (videoWidth && videoHeight) {
                    const isPortrait = videoHeight > videoWidth;
                    videoElement.classList.remove('vjs-portrait', 'vjs-landscape');
                    videoElement.classList.add(isPortrait ? 'vjs-portrait' : 'vjs-landscape');
                }
            });

            if (shouldShowSpinner) {
                player.on('canplay', () => {
                    setIsVideoReady(true);
                });
            }

            if (onVideoCanPlay) {
                let hasFired = false;
                const fireOnce = () => {
                    if (hasFired) return;
                    hasFired = true;
                    if (fallbackTimerRef.current) {
                        clearTimeout(fallbackTimerRef.current);
                        fallbackTimerRef.current = null;
                    }
                    onVideoCanPlay();
                };

                player.one('playing', fireOnce);
                player.one('canplay', () => {
                    fallbackTimerRef.current = setTimeout(fireOnce, 500);
                });
            }
        }));

        if (suppressNativePoster) {
            const posterValue = options.poster || 'about:blank';
            const nativeVideo = videoElement.querySelector('video');
            nativeVideo?.setAttribute('poster', posterValue);

            player.on('loadstart', () => {
                const techEl = player.tech(true)?.el();
                techEl?.setAttribute('poster', posterValue);
            });
        }

        if (videoRef.current) {
            // @ts-expect-error — ref typing
            videoRef.current.appendChild(videoElement);
        }
    }, []);

    useEffect(() => {
        return () => {
            if (fallbackTimerRef.current) {
                clearTimeout(fallbackTimerRef.current);
                fallbackTimerRef.current = null;
            }
            const player = playerRef.current;
            // @ts-expect-error sdfsd
            if (player && !player?.isDisposed()) {
                // @ts-expect-error asdfasd
                player?.dispose();
                playerRef.current = null;
            }
        };
    }, [playerRef]);

    return (
        <div className="video-player-component" data-vjs-player>
            {shouldShowSpinner && !isVideoReady && <Spinner />}
            <div className="video-js-wrapper" ref={videoRef} hidden={shouldShowSpinner && !isVideoReady} />
        </div>
    );
};
